import { render, staticRenderFns } from "./ShowOccurrences.vue?vue&type=template&id=74bbc677&scoped=true&"
import script from "./ShowOccurrences.vue?vue&type=script&lang=js&"
export * from "./ShowOccurrences.vue?vue&type=script&lang=js&"
import style0 from "./ShowOccurrences.vue?vue&type=style&index=0&id=74bbc677&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bbc677",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VDialog,VIcon})
